/** The value-type table of §4.5, one function per operator family. Null means the combination is FL-E04. */
/** A subexpression that already failed its check absorbs whatever it meets: the failure was reported there. */
function involvesUnknown(left, right) {
    return left === 'Unknown' || right === 'Unknown';
}
/** `X ± X → X`; `Plain ± X` is an error except for the literal `0`. Also the rule for `??`, `?:` and `if()` branches. */
export function addValueTypes(left, right, leftIsZeroLiteral, rightIsZeroLiteral) {
    if (involvesUnknown(left, right))
        return 'Unknown';
    if (left === right)
        return left;
    if (left === 'Plain' && leftIsZeroLiteral)
        return right;
    return right === 'Plain' && rightIsZeroLiteral ? left : null;
}
/** `Quantity × Rate → Amount`; `X × Ratio → X`; `X × Plain → X`; and commuted. Everything else is an error. */
export function multiplyValueTypes(left, right) {
    if (involvesUnknown(left, right))
        return 'Unknown';
    if (left === 'Plain' || left === 'Ratio')
        return right;
    if (right === 'Plain' || right === 'Ratio')
        return left;
    const isQuantityTimesRate = (left === 'Quantity' && right === 'Rate') || (left === 'Rate' && right === 'Quantity');
    return isQuantityTimesRate ? 'Amount' : null;
}
/** `Amount ÷ Quantity → Rate`; `Amount ÷ Amount`, `Quantity ÷ Quantity → Ratio`; `X ÷ Plain → X`. Everything else is an error. */
export function divideValueTypes(left, right) {
    if (involvesUnknown(left, right))
        return 'Unknown';
    if (right === 'Plain')
        return left;
    if (left === 'Amount' && right === 'Quantity')
        return 'Rate';
    const isLikeOverLike = left === right && (left === 'Amount' || left === 'Quantity');
    return isLikeOverLike ? 'Ratio' : null;
}
/** Comparable value types: the same, or either side Plain. */
export function sameOrPlain(left, right) {
    return left === right || left === 'Plain' || right === 'Plain' || left === 'Unknown' || right === 'Unknown';
}
